import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import { EntityLink } from "~/components/entity-link";
import type { magazinesStyleArticleMoreOnThisContentItemContent$key } from "~/queries/__generated__/magazinesStyleArticleMoreOnThisContentItemContent.graphql";

import { Container, Headline } from "./styles";

export type Props = {
  reference: magazinesStyleArticleMoreOnThisContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemMagazinesStyleArticleMoreOnThis = forwardRef<HTMLDivElement, Props>(
  ({ className, provider, reference }, elementReference) => {
    const article = useFragment(
      graphql`
        fragment magazinesStyleArticleMoreOnThisContentItemContent on Content {
          ...entityLink
          ...helpersCheckIsMainTopicContent
        }
      `,
      reference,
    );

    return (
      <Container className={className} ref={elementReference}>
        <EntityLink reference={article}>
          {provider.coverImage({
            responsiveVariants: {
              desktopUp: "size768x768",
              mobileUp: "size768x768",
              tabletUp: "size768x768",
            },
          })}

          <Headline>{provider.headline({ preferSocialHeadline: true })}</Headline>
        </EntityLink>
      </Container>
    );
  },
);

ContentItemMagazinesStyleArticleMoreOnThis.displayName =
  "ContentItemMagazinesStyleArticleMoreOnThis";
